import {
  addDays,
  format,
  getDay,
  isBefore,
  isToday,
  isTomorrow,
  startOfDay,
  startOfToday,
} from "date-fns";

export const generateCalendarDaysForMonth = (year: number, month: number) => {
  const today = new Date();
  const isCurrentMonth =
    today.getFullYear() === year && today.getMonth() === month;

  const startDate: Date = isCurrentMonth ? today : new Date(year, month, 1);

  const startDay = getDay(startDate);
  const daysBack = (startDay + 6) % 7;
  const tentativeStart = addDays(startDate, -daysBack);
  const adjustedStart =
    tentativeStart.getMonth() === month ? tentativeStart : startDate;

  const lastDayOfMonth = new Date(year, month + 1, 0);
  const endDay = getDay(lastDayOfMonth);
  const adjustedEnd =
    endDay === 0 ? lastDayOfMonth : addDays(lastDayOfMonth, 7 - endDay);

  const days: any[] = [];
  let current = adjustedStart;

  const todayStart = startOfToday();

  while (current <= adjustedEnd) {
    const isPast = isBefore(startOfDay(current), todayStart);

    days.push({
      date: current,
      dayOfWeek: format(current, "EEE").toUpperCase(),
      dayNumber: current.getDate(),
      isToday: isToday(current),
      isTomorrow: isTomorrow(current),
      isAvailable: !isPast,
    });

    current = addDays(current, 1);
  }

  return days;
};
